export default "<div style=\"text-align: center\" *ngFor=\"let message of messages\">\n  {{ message }}\n</div>\n";